import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import uidevComponent from 'uidev-component';
import {uidevGrid} from 'uidev-component';
import 'uidev-component/styles/token/theme/uidevCompOverride.scss'
import './styles/fonts.scss'
import './styles/grid.scss'
import './styles/custom.scss'
import Vue2Editor  from "vue2-editor";
import wysiwyg from "vue-wysiwyg";
import '@toast-ui/editor/dist/toastui-editor.css';

import { Editor } from '@toast-ui/vue-editor';
import AutoLogout from './components/user/AutoLogout.vue';
import VueSkeletonLoader from 'skeleton-loader-vue';
import { VueSelect } from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false
Vue.use(uidevComponent);
Vue.use(uidevGrid);
Vue.use(Vue2Editor);
Vue.use(wysiwyg, {});
Vue.use(Editor);
Vue.component('auto-logout', AutoLogout);
// Register the component globally
Vue.component('vue-skeleton-loader', VueSkeletonLoader);
Vue.component('v-select', VueSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
